// Auto-generated file created by svgr-cli source svg-template.js
// Run pnpm run create to update
// Do not edit
import * as React from 'react';
import type { SVGProps } from 'react';
const SvgAustraliav = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    aria-hidden="true"
    {...props}
  >
    <g
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      clipPath="url(#australiav_svg__a)"
    >
      <path d="M21.429 9.72c.569.761 1.234 1.584 1.203 2.743a7.965 7.965 0 0 1-1.375 4.186c-.22.389-.39.804-.507 1.234 0 .223.127.762-.686.92-.812.157-1.207.397-1.55.253a3.523 3.523 0 0 1-.63-.38 2.19 2.19 0 0 1-1.2.524c-.6 0-2.311-1.33-2.596-2.4-.254.161-.442.285-.569.254-.127-.031-.285 0-1.107-.727-.823-.727-1.296-.885-1.93-.854-.635.031-2.185.95-4.43 2.434-1.454.686-1.992.508-2.373.162a1.029 1.029 0 0 1-.189-.686c0-.343.124-.538-.507-1.3-.63-.76-2.026-3.864-1.488-5.382.538-1.52 2.469-1.077 3.353-1.992.885-.916.686-1.804 2.122-3.261.666-.665.686-.885 1.612-.411l.446.284s.25-.686.342-.915c.093-.23.069-.635.916-.761.847-.127 2.657-.22 3.226.065M16.303 6.336v5.949" />
      <path d="M14.815 4.056c0-.823.666-2.595 1.52-2.595.853 0 1.518 1.772 1.518 2.626 0 .854-.662 2.184-1.484 2.184-.823 0-1.554-1.392-1.554-2.215zM17.143 6.857c.685-.686 2.609-1.536 3.274-.902.665.635-.223 2.596-.885 3.258-.661.661-2.28 1.203-2.91.538-.631-.665-.127-2.246.52-2.894z" />
      <path d="M16.019 9.768c-.631.665-2.246.123-2.911-.538-.665-.662-1.55-2.623-.885-3.257.665-.635 2.592.219 3.257.884.665.648 1.17 2.246.539 2.911zM17.568 21.175c-.22-.796.158-1.073.38-1.138.224-.066.731.126.889.126.158 0 .569-.096.788-.096a.73.73 0 0 1 .73.823c0 .696-.572 1.615-1.456 1.615-.666 0-1.111-.535-1.33-1.33z" />
    </g>
    <defs>
      <clipPath id="australiav_svg__a">
        <path
          fill="#fff"
          d="M0 0h24v24H0z"
        />
      </clipPath>
    </defs>
  </svg>
);
export default SvgAustraliav;
